import React from "react";
import { gql, useQuery } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import TableLink from "../TableLink";
import { assemblePlayerPerformanceFilter } from "../../utils/filters";

const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
    overflowX: "auto",
    margin: "auto"
  }
});

const GET_PLAYER_YEAR = gql`
  query playerYearQuery(
    $first: Int
    $offset: Int
    $orderBy: [_PlayerCareerOrdering]
    $filter: _PlayerPerformanceFilter
  ) {
    PlayerYear: PlayerCareer(
      first: $first
      offset: $offset
      orderBy: $orderBy
      filter: $filter
    ) {
      id
      name
      powers
      points
      gets
      negs
      tossups_heard
      pp20tuh
    }
  }
`;

function Player(props) {
  const { classes, year, orderBy } = props;
  const order = "desc";
  const [page, setPage] = React.useState(0);
  const rowsPerPage = 10;
  const filterState = assemblePlayerPerformanceFilter({
    years: [year],
    tournamentType: "College"
  });

  const { loading, data, error } = useQuery(GET_PLAYER_YEAR, {
    variables: {
      first: rowsPerPage,
      offset: rowsPerPage * page,
      orderBy: `${orderBy}_${order}`,
      filter: filterState
    }
  });

  const handleChangePage = (_, page) => {
    setPage(page);
  };

  return (
    <div>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <TableCell key="rank"></TableCell>
                <TableCell key="name">Name</TableCell>
                <TableCell key="value">
                  {orderBy === "pp20tuh"
                    ? orderBy.toUpperCase()
                    : orderBy.charAt(0).toUpperCase() + orderBy.slice(1)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.PlayerYear.map((n, i) => {
                return (
                  <TableRow key={n.id}>
                    <TableCell component="th" scope="row">
                      {i + page * rowsPerPage + 1}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <TableLink to={`/player/${n.id}`}>{n.name}</TableLink>
                    </TableCell>
                    <TableCell>{n[orderBy]?.toLocaleString()}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            count={Number.MAX_VALUE}
            labelDisplayedRows={({ from, to }) => `Results ${from} - ${to}`}
            nextIconButtonProps={
              data.PlayerYear.length < rowsPerPage ? { disabled: true } : {}
            }
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
          />
        </div>
      )}
    </div>
  );
}

export default withStyles(styles)(Player);
